// extracted by mini-css-extract-plugin
module.exports = {"container":"KpiPage_container__87KpY","content":"KpiPage_content__A6Skc","stepContainer":"KpiPage_stepContainer__3-zaF","dateRangeContainer":"KpiPage_dateRangeContainer__3QObN"};